import { render } from "./ContentblockExhibitions.vue?vue&type=template&id=86414a00&scoped=true&ts=true"
import script from "./ContentblockExhibitions.ts?vue&type=script&lang=ts"
export * from "./ContentblockExhibitions.ts?vue&type=script&lang=ts"

import "./ContentblockExhibitions.scss?vue&type=style&index=0&id=86414a00&lang=scss&scoped=true"

import exportComponent from "/Users/koenverbruggen/Sites/02-SITES/nederlandsmijnmuseum.local/wp-content/themes/nmm/js/vue/nmm/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-86414a00"]])

export default __exports__